import React, { Component } from 'react';
import dayjs from 'dayjs';
import {
  formatCurrency,
  TableGrid,
  export2Excel,
  export2PDF,
} from '@C/TableGrid';
import services from '@C/Reports/_utils/data';
import { POSList } from '@C/Reports/_utils/POSList';
import DropLoaderLarge from '@C/Utils/DropLoaderLarge';

const col = [
  {
    name: 'Date',
    key: 'date',
    sortable: true,
    type: 'date',
  },
  {
    name: 'Narration',
    key: 'narration',
  },
  {
    name: 'Credit',
    key: 'all',
    formatter(props) {
      return <>{formatCurrency(props.credit)}</>;
    },
  },
  {
    name: 'Debit',
    key: 'all',
    formatter(props) {
      return <>{formatCurrency(props.debit)}</>;
    },
  },
  {
    name: 'Balance',
    key: 'all',
    formatter(props) {
      return <>{formatCurrency(props.outstanding)}</>;
    },
  },
];

class POSLedger extends Component {
  constructor(props) {
    super(props);
    this.state = {
      swipeList: [],
      bank_id: '',
      start_date: dayjs().subtract(1, 'month').format('YYYY-MM-DD'),
      end_date: dayjs().format('YYYY-MM-DD'),
      loading: false,
      limit: 20,
      offset: 1,
      count: 0,
    };
    this.limitInput = React.createRef();
  }

  componentDidMount() {
    this.getMappedPOS();
    const observer = new IntersectionObserver(this.handleObserver.bind(this), {
      threshold: 0.5,
    });
    this.setState({ observer });
    observer.observe(this.loader);
  }

  componentWillUnmount() {
    const { observer } = this.state;
    if (observer) {
      observer.disconnect();
    }
  }

  getMappedPOS = () => {
    services
      .getMappedPOS()
      .then((response) => {
        const tmp = response.data.data;
        const CategoryOptions = [];
        for (let i = 0; i < tmp.length; i++) {
          CategoryOptions.push({
            value: tmp[i].bunk_card_uuid,
            label: tmp[i].name,
          });
        }
        this.setState(
          {
            swipeList: CategoryOptions,
            bank_id: CategoryOptions[0].value,
          },
          function () {
            this.getPOSLedger();
          },
        );
      })

      .catch((error) => {
        console.log(error);
      });
  };

  handleObserver(entities) {
    const { loading, count, limit, offset } = this.state;
    const loadMore = entities[0];
    if (loadMore.isIntersecting && !loading && count > offset * limit) {
      this.setState(
        (prevState) => ({ offset: prevState.offset + 1, loading: true }),
        () => this.getPOSLedger(),
      );
    }
  }

  handleQuickSearch = (e) => {
    if (e.target.value === '' || e.target.value === '0') {
      return;
    }
    this.setState({ limit: e.target.value, offset: 1 }, function () {
      this.getPOSLedger();
    });
  };

  handleDropChange = (e) => {
    this.setState({ bank_id: e.value });
  };

  getPOSLedger = () => {
    const { bank_id, start_date, end_date, limit, offset } = this.state;
    this.setState({ loading: true });
    services
      .getPOSLedger({ bank_id, start_date, end_date, limit, offset })
      .then((response) => {
        this.setState((prevState) => ({
          swipeList:
            offset === 1
              ? response.data.data.results
              : [...prevState.swipeList, ...response.data.data.results],
          count: response.data.data.count,
          loading: false,
        }));
      })
      .catch((err) => {
        this.setState({ loading: false });
      });
  };

  handleDateChange = (e) => {
    const { name, value } = e.target;
    if (name === 'start_date' && dayjs(value).isAfter(this.state.end_date)) {
      this.setState({ [name]: value, end_date: value });
    } else if (
      name === 'end_date' &&
      dayjs(value).isBefore(this.state.start_date)
    ) {
      this.setState({ [name]: value, start_date: value });
    } else {
      this.setState({ [name]: value });
    }
  };

  resetFilter = () => {
    this.setState(
      {
        start_date: dayjs().subtract(1, 'month').format('YYYY-MM-DD'),
        end_date: dayjs().format('YYYY-MM-DD'),
        loading: true,
        bank_id: '',
        limit: 20,
        offset: 1,
      },
      function () {
        this.getPOSLedger();
      },
    );
  };

  submitForm = (e) => {
    e.preventDefault();
    this.setState({ offset: 1 }, function () {
      this.getPOSLedger();
    });
  };

  render() {
    const { swipeList } = this.state;
    const exportOptions = {
      fileName: `Swipe Ledger - ${this.state.start_date} to ${this.state.end_date}`,
      reportName: 'Swipe Ledger Report',
      reportDate: `Date - ${dayjs(this.state.start_date).format('D MMM YY')} to ${dayjs(this.state.end_date).format('D MMM YY')}`,
      reportTotal: `Total amount -  ${
        swipeList[0]?.outstanding?.toFixed(2) || 0
      }`,
      reportQuantity: '',
      reportSales: '',
      reportTesting: '',
      reportBowser: '',
      reportCustomerName: '',
      reportGst: '',
      reportOpeningBalance: '',
      reportClosingBalance: '',
      reportSaleTotal: '',
      reportTCSTotal: '',
    };
    return (
      <section className="widget list-table full-width inverted">
        <header>
          <div className="stock-info-headers">
            <h3>POS Ledger ({this.state.count})</h3>
            <div className="mini-summary">
              <ul>
                <li>
                  <span> Closing balance: </span>
                  <span>{formatCurrency(swipeList[0]?.outstanding || 0)}</span>
                </li>
              </ul>
            </div>
          </div>
          <div className="action">
            <button className="submit" type="submit" onClick={this.submitForm}>
              Filter
            </button>
            <button
              onClick={this.resetFilter}
              className="reset-filter"
            ></button>
          </div>
          <div className="export-btns">
            <button
              onClick={() => export2Excel(exportOptions)}
              className={`blue-btn btn-with-icon btn-with-icon__excel action-btn ${this.state.exportingExcel ? 'loading' : ''}`}
              title="Export to Excel"
            >
              Export to Excel
            </button>
            <button
              onClick={() => export2PDF(exportOptions)}
              className={`blue-btn btn-with-icon btn-with-icon__pdf action-btn ${this.state.exportingPdf ? 'loading' : ''}`}
              title="Export to PDF"
            >
              Export to PDF
            </button>
          </div>
        </header>
        <main>
          <div className="table-filters">
            <div className="filter-wrapper">
              <div className="filter-group">
                <label>From date:</label>
                <input
                  className="cstm-date-input"
                  type="date"
                  value={this.state.start_date}
                  name="start_date"
                  onChange={this.handleDateChange}
                />
              </div>
              <div className="filter-group">
                <label>To date:</label>
                <input
                  className="cstm-date-input"
                  type="date"
                  value={this.state.end_date}
                  min={this.state.start_date}
                  onChange={this.handleDateChange}
                  name="end_date"
                />
              </div>

              <div className="filter-group">
                <label>Select POS machine:</label>
                <POSList
                  handleBankChange={this.handleDropChange}
                  value={this.state.bank_id}
                  ref={(ref) => {
                    this.POSListRef = ref;
                  }}
                />
              </div>
            </div>
          </div>
          <div className="table-wrapper">
            {(() => {
              if (this.state.loading) {
                return <DropLoaderLarge />;
              } else {
                return (
                  <TableGrid
                    col={col}
                    row={swipeList}
                    offset={this.state.offset}
                    count={this.state.count}
                    limit={this.state.limit}
                    pagination="disabled"
                    hideActions={true}
                    enableExport={false}
                    recordsFilter={this.handleQuickSearch}
                    exportOptions={{
                      fileName: `Swipe Ledger - ${this.state.start_date} to ${this.state.end_date}`,
                      reportName: 'Swipe Ledger Report',
                      reportDate: `Date - ${dayjs(this.state.start_date).format('D MMM YY')} to ${dayjs(this.state.end_date).format('D MMM YY')}`,
                      reportTotal: `Total amount -  ${
                        swipeList[0]?.outstanding?.toFixed(2) || 0
                      }`,
                      reportQuantity: '',
                      reportSales: '',
                      reportTesting: '',
                      reportBowser: '',
                      reportCustomerName: '',
                      reportGst: '',
                      reportOpeningBalance: '',
                      reportClosingBalance: '',
                      reportSaleTotal: '',
                      reportTCSTotal: '',
                    }}
                  />
                );
              }
            })()}
            <div
              ref={(ref) => {
                this.loader = ref;
              }}
            ></div>
          </div>
        </main>
      </section>
    );
  }
}

export { POSLedger };
